import React from 'react';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop';
import { Home, PlatformPage, UseCasesPage } from './components/Home';
import './App.css';
export default function App() {
    return <BrowserRouter><ScrollToTop /><a className="skip-link" href="#main">Skip to content</a><Header /><div id="main" tabIndex={-1}><Routes>
    <Route path="/" element={<Home />}/><Route path="/solution" element={<PlatformPage />}/><Route path="/industries" element={<UseCasesPage />}/><Route path="/contact" element={<Contact />}/><Route path="/privacy-policy" element={<PrivacyPolicy />}/><Route path="*" element={<main className="wrap page-intro"><p className="eyebrow">404 / PAGE NOT FOUND</p><h1>A connection<br />we couldn’t find.</h1><Link className="button" to="/">Back to home ↗</Link></main>}/>
  </Routes></div><Footer /></BrowserRouter>;
}
